/**
 * Stable CSS class names for E2E — Rule template grid (table + dialog + pagination).
 */
export const RTTPG = {
    root: 'rule-template-grid',
    tablePaper: 'rule-template-grid__table-paper',
    table: 'rule-template-grid__table',
    head: 'rule-template-grid__head',
    headRow: 'rule-template-grid__head-row',
    headCell: 'rule-template-grid__head-cell',

    body: 'rule-template-grid__body',
    row: 'rule-template-grid__row',
    cell: 'rule-template-grid__cell',
    cellId: 'rule-template-grid__cell--id',
    cellTenant: 'rule-template-grid__cell--tenant',
    cellName: 'rule-template-grid__cell--name',
    cellCriteriaCount: 'rule-template-grid__cell--criteria-count',
    cellActions: 'rule-template-grid__cell--actions',

    criteriaChip: 'rule-template-grid-input--chip-criteria-count',
    editButton: 'rule-template-grid-input--button-edit',
    deleteButton: 'rule-template-grid-input--button-delete',
    editIcon: 'rule-template-grid__edit-icon',
    deleteIcon: 'rule-template-grid__delete-icon',

    pagination: 'rule-template-grid__pagination',

    detailsDialog: 'rule-template-grid__details-dialog',
    detailsDialogTitle: 'rule-template-grid__details-dialog-title',
    detailsDialogTitleLayout: 'rule-template-grid__details-dialog-title-layout',
    detailsDialogTitleName: 'rule-template-grid__details-dialog-title-name',
    detailsDialogCloseButton: 'rule-template-grid-input--button-dialog-close',
    detailsDialogCloseIcon: 'rule-template-grid__details-dialog-close-icon',
    detailsDialogContent: 'rule-template-grid__details-dialog-content',

    detailsTable: 'rule-template-grid__details-table',
    detailsHead: 'rule-template-grid__details-head',
    detailsHeadRow: 'rule-template-grid__details-head-row',
    detailsHeadCell: 'rule-template-grid__details-head-cell',
    detailsBody: 'rule-template-grid__details-body',
    detailsRow: 'rule-template-grid__details-row',
    detailsCell: 'rule-template-grid__details-cell',
} as const;

export const rttpgCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

